export const ONE_TRUST_CONSENT_CATEGORY_FOR_HOTJAR = 'C0007'
export const ONE_TRUST_CONSENT_CATEGORY_FOR_MIXPANEL = 'C0002'

export const ONE_TRUST_CONSENT_GIVEN = '1'
export const ONE_TRUST_CONSENT_REFUSED = '0'
export const ONE_TRUST_CONSENT_KEY = 'groups'

export const ONE_TRUST_COOKIE_ALERTBOX_KEY = 'OptanonAlertBoxClosed'
export const ONE_TRUST_COOKIE_CONSENTS_KEY = 'OptanonConsent'
export const ONE_TRUST_URI_QUERY_PARAM_KEY = 'otConsentString'

export const ONE_TRUST_EVENT_NAME = 'tsf.event:optanon'

export const ONE_TRUST_GLOBAL_VARIABLE_KEY = 'OnetrustActiveGroups'
